import axios from "axios";
import { ITEMS } from "../constantes";
export const GET_ITEMS = 'GET_ITEMS';
export const POST_ITEMS = 'POST_ITEMS';
export const DELETE_ITEMS = 'DELETE_ITEMS';
export const PUT_ITEMS = 'PUT_ITEMS';
export const GET_ITEMS_ID = 'GET_ITEMS_ID';
export const PUT_ITEMS_VALUE = 'PUT_ITEMS_VALUE';
export const PUT_VALUE_MASSIVE = 'PUT_VALUE_MASSIVE';
export const VALUE_MASSIVE_ERROR = 'VALUE_MASSIVE_ERROR';
export const ITEMS_VALUE_ERROR = 'ITEMS_VALUE_ERROR';
export const CLEAR_MESSAGES = 'CLEAR_MESSAGE';


export const getItems = () => async dispatch => {
    await axios.get(ITEMS)
        .then((res) => {
            dispatch({
                type: GET_ITEMS,
                payload: res.data
            })
        })
        .catch((err) => {console.log(err)})
}

export const getItemsId = (id) => async dispatch => {
    try {
        await axios.get(`${ITEMS}/${id}`)
        .then(res => {
            dispatch({
                type: GET_ITEMS_ID,
                payload: res.data
            })
        })
    } catch (error) {
        console.log(error);        
    }
}

export const postItems = (payload) => async dispatch => {
    try {
        await axios.post(ITEMS, payload)
           .then(res => {
                dispatch({
                    type: POST_ITEMS,
                    payload: res.data
                })
            })
    } catch (error) {
        return (error)
    }
}

export const putItems = (payload) => async dispatch => {
    try {
        await axios.post(`${ITEMS}/modify`, payload)
        .then(res => {
            dispatch({
                type: PUT_ITEMS,
                payload: res.data
            })
        })
    } catch (error) {
        console.log(error)        
    }
}

export const deleteItems = (id) => async dispatch => {
    try {
        await axios.delete(`${ITEMS}/${id}`)
        .then(res => {
            dispatch({
                type:DELETE_ITEMS,
                payload: res.data
            })
        })
    } catch (error) {
        
    }
}

export const itemsValue = (payload) => async dispatch => {
    console.log(payload);
    
    try {
        await axios.patch(`${ITEMS}/value`, payload)
        .then(res => {
            dispatch({
                type: PUT_ITEMS_VALUE,
                payload: res.data
            })
        })
    } catch (error) {
        console.log(error);
        dispatch({
                type: ITEMS_VALUE_ERROR,
                payload: error.response.data
            })
    }
}

export const priceMassive = (payload) => async dispatch => {
    console.log(payload);
    
    try {
        await axios.patch(`${ITEMS}/value/massive`, payload)
        .then(res => {
            dispatch({
                type: PUT_VALUE_MASSIVE,
                payload: res.data
            })
            console.log(res.data);
            
        })
    } catch (error) {
        console.log(error);
        dispatch({
                type: VALUE_MASSIVE_ERROR,
                payload: error.response.data
            })
        
    }
}

export const clearMessage = () => async dispatch => {
    dispatch({
        type: CLEAR_MESSAGES,
        payload: null
    })
}

/*
await fetch("/api/items/bulk-price", {
  method: "PATCH",
  headers: {
    "Content-Type": "application/json"
  },
  body: JSON.stringify({ items })
});
*/